import React from "react";
import Typography from '@mui/material/Typography';
import { makeStyles} from '@mui/styles';
//import { createTheme, responsiveFontSizes, adaptV4Theme} from '@mui/material/styles';
import SvgIcon from "@mui/material/SvgIcon";
import Grid from '@mui/material/Grid';
import Carousel from 'react-material-ui-carousel'
import Divider from '@mui/material/Divider';
import {globalTheme} from "../components/Theme"
import Image from 'material-ui-image'
import ReactPlayer from 'react-player/lazy'
import Link from '@mui/material/Link';
import Icon from '@mui/material/Icon';
import Button from '@mui/material/Button';
import { ParallaxBanner } from 'react-scroll-parallax';
import {background} from  "../assets";
import { useEffect, useLayoutEffect, useState} from "react";
import { useLocation } from "react-router-dom";

// let theme = createTheme(adaptV4Theme({
//   typography: {
//       h1: {
//           fontWeight: 500
//       },
//   },
// }, globalTheme));
// theme = responsiveFontSizes(theme);


const useStyles = makeStyles((theme) => ({
    root: {
      paddingTop: theme.spacing(5),
      paddingBottom: theme.spacing(5)
    },
    carousel:{
      minWidth: "100%",
      maxWidth: "1152px",
    },
    imgContainer: {
      width: "90%",
      maxWidth: "1152px",
      height: "100%",
      backgroundColor: "rgb(23, 26, 33)",
      padding: theme.spacing(1),
      marginBottom: theme.spacing(5),
      [theme.breakpoints.up('md')]: {
        width: "75%",
      }
    },
    projectTitle: {
      paddingTop: "30px",
      fontWeight: 550
    },
    grid:{
      width: "100%",
      height: "100%",
      paddingTop: "20px",
      position: "relative",
    },
    info: {
      //zIndex: -2,
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(2),
      backgroundColor: "rgba(0,0,0,0.5)",
      width: "80%",
      maxWidth: "1280px",
      paddingLeft: theme.spacing(4),
      paddingRight: theme.spacing(4),
      // marginLeft: theme.spacing(2),
      // marginRight: theme.spacing(2),
      [theme.breakpoints.down('lg')]: {
        width: "100%",
        //paddingRight: theme.spacing(5)
      },
    },
    description: {
      width: "100%",
      paddingBottom: "30px",
      fontSize: "18px"
    },
    heading: {
      width: "100%",
      fontWeight: 500,
    },
    subheading: {
      width: "100%",
      opacity: "0.8",
      zIndex: 0
    },
    date: {
      paddingTop: "20px",
      fontStyle:"italic",
      opacity: "0.8",
      zIndex: -1,
    },
    img: {
      zIndex: -1,
      height: "100%",
      width: "100%",
      objectFit: "cover"
    },
    purpose: {
      fontStyle:"italic",
      opacity: "0.8",
      zIndex: -1,
    },
    playerWrapper: {
      position: "relative",
      paddingTop: "56.25%",
    },
    player:{
      position: "absolute",
      top: "0",
      left: "0",
    },
    audioPlayer: {
      position: "absolute",
      bottom: "44%",
      left: "20%",
    },
    gridItem: {
      width: "50%",
      paddingRight: "15px",
      [theme.breakpoints.down('md')]: {
        width: "100%",
      },
    },
    svgIcon: {
      stroke:"white",
      strokeOpacity: "30%",
      strokeWidth:"5px",
      marginLeft: "8px",
      position: "relative",
      top: "4px"
    },
    links: {
      zIndex: 1000
    },
    li: {
      marginLeft: "25px"
    }
  }));

function useWindowSize() {
  const [size, setSize] = useState([0, 0]);
  useLayoutEffect(() => {
    function updateSize() {
      setSize([window.innerWidth, window.innerHeight]);
    }
    window.addEventListener('resize', updateSize);
    updateSize();
    return () => window.removeEventListener('resize', updateSize);
  }, []);
  return size;
}

export default function ProjectCard(props){
    const classes = useStyles(globalTheme);
    const aboutData = props.descData;
    const mediaData = props.mediaData;
    const location = useLocation();
    const DELAY_MS_BEFORE_SCROLL = 100;
    // const targetRef = useRef(undefined);
    const [width, ] = useWindowSize();

    useEffect(() => {
      //console.log('Location changed');
      setTimeout(props.scrollToDiv, DELAY_MS_BEFORE_SCROLL);

    }, [location, props]);

    return (
      (<div className={classes.root} key={props.ref+"_cardRef"}>
        <Divider style={globalTheme.palette.dividerColor} />
        <Typography variant="h3" align="center" gutterBottom className={classes.projectTitle} style={globalTheme.palette.heading}>
          {aboutData.projName}
        </Typography>
        <Divider style={globalTheme.palette.dividerColor}/>

        {/* Project date and purpose */}
        <Typography variant="h5" align="center" className={classes.date} style={globalTheme.palette.heading}>
            {aboutData.date}
            <br></br>
            {aboutData.timeframe}
        </Typography>
        <Typography variant="h6" align="center" className={classes.purpose} style={globalTheme.palette.heading}>
            {aboutData.purpose}
          </Typography>
        <Grid
          container
          direction="column"
          justifyContent="center"
          alignItems="center"
          className={classes.grid}
        >
          <div className={classes.imgContainer}>
            <Carousel
              className={classes.carousel}
              navButtonsAlwaysVisible
              fullHeightHover
              autoPlay={false}
              timeout={300}
              height={Math.min(width * (9/16) * (0.75), 648)}
              //interval={12000}
            >
              {
                mediaData.map((media, index) => (
                  (media.type === "img" ?
                      <Image 
                        key={media.img + index} 
                        src={media.img} 
                        alt={media.title}
                        color= "rgba(253, 236, 239, 0.5)"
                        disableTransition
                        aspectRatio={(16/9)}
                        imageStyle={ {width:"100%", height:"100%", objectFit:"contain", backgroundColor: "rgb(23, 26, 33)"} }
                      />
                  :
                    media.type === "audio" ?
                      <div key={media.url} className={classes.playerWrapper}>
                        <ReactPlayer 
                          className={classes.audioPlayer}
                          url={[media.url]}
                          width='60%'
                          height='54px'
                          controls
                          config={{
                            youtube: {
                              playerVars: { autoplay: 0 }
                            },
                            file: {
                              attributes: {
                                autoPlay:false,
                                loop:false,
                                playsInline: true
                              }
                            }
                          }}
                        />
                      </div>
                    :
                      <div key={media.url} className={classes.playerWrapper}>
                        <ReactPlayer 
                          className={classes.player}
                          url={[media.url]}
                          width='100%'
                          height='100%'
                          config={{
                            youtube: {
                              playerVars: { autoplay: 0 }
                              // embedOptions: {
                              //   width: "100%",
                              //   height: Math.min(width * (9/16) * (0.75), 648) + "px"
                              // }
                            },
                            file: {
                              attributes: {
                                autoPlay:true,
                                loop:true,
                                muted:true,
                                playsInline: true
                              }
                            }
                          }}
                        />
                        </div>
                    )
                ))
              }       
            </Carousel>

            <ParallaxBanner
              layers={[
                  {
                    image: background,
                    speed: -30,
                    translateY: [-10, 10],
                    shouldAlwaysCompleteAnimation: true,
                    // targetElement: targetRef.current
                  },
              ]}
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                height: "100%",
                width: "100%",
                zIndex: -999,
                padding: "10px 0px"
              }}
            >
              
            </ParallaxBanner>
          </div>
          
          <Grid
            container
            direction="row"
            alignItems="flex-start"
            className={classes.info}
          >
              {/* About */}
              <Typography variant="h3" className={classes.heading} style={globalTheme.palette.heading}>
                About 
              </Typography>
              <Typography variant="body1" className={classes.description}>
                {aboutData.about}
              </Typography>

              {/* Features of the project */}
              {aboutData.features !== undefined &&
              <Grid 
                item
                className={classes.gridItem}
              >
                <Typography variant="h4" className={classes.subheading} style={globalTheme.palette.heading}>
                  Features
                </Typography>
                <Typography variant="body1" className={classes.description}>
                  {aboutData.features.map((li, index) => (
                      <li className={classes.li} key={index}>{li}</li>
                  ))}
                </Typography>
              </Grid>
              }

              <Grid 
                item
                className={classes.gridItem}
              >
                {/* Technologies used */}
                <Typography variant="h4" className={classes.subheading} style={globalTheme.palette.heading}>
                  Technologies
                </Typography>
                <Typography variant="subtitle1" className={classes.description}>
                  {aboutData.technologies.map((technology, index) => (
                      <li className={classes.li} key={index}>
                        {technology.text}
                        <SvgIcon 
                          className={classes.svgIcon} 
                          key={technology.text + "_projectsCard_icon"}
                        >
                        {
                            technology.icon
                        }
                        </SvgIcon>
                      </li>
                  ))}
                </Typography>
              </Grid>

              {/* Contributors if there are multiple developers */}
              {aboutData.contributors != null && aboutData.contributors.length > 1 &&
                <React.Fragment>
                <Grid 
                  item
                  className={classes.gridItem}
                >
                  <Typography variant="h4" className={classes.subheading} style={globalTheme.palette.heading}>My Teammates</Typography>
                  <Typography variant="subtitle1" className={classes.description}>
                    {aboutData.contributors.map((li, index) => (
                        <li className={classes.li} key={index}>{li}</li>
                    ))}
                  </Typography>
                </Grid>
                </React.Fragment>
              }

              {/* If there are too many contributors, contributions can be by themselves */}
              {aboutData.contributions != null &&
                <Grid 
                  item
                  className={classes.gridItem}
                >
                  {/* My Contributions if there are multiple developers */}
                  <Typography variant="h4" className={classes.subheading} style={globalTheme.palette.heading}>My Contributions</Typography>
                    <Typography variant="subtitle1" className={classes.description}>
                      {aboutData.contributions.map((li, index) => (
                        <li className={classes.li} key={index}>{li}</li>
                        ))
                      }
                    </Typography>
                </Grid>
              }

              {/* Links to project files if there are any*/}
              {aboutData.links !== undefined &&
                <React.Fragment>
                  <Typography variant="h4" className={classes.subheading} style={globalTheme.palette.heading}>Links</Typography>
                  <Grid 
                    container
                    direction="row"
                    justifyContent="flex-start"
                    alignItems="center">
                  {aboutData.links.map((link, index) => (
                    <Link key={link.name + link.url} href={link.url} target="_blank" rel="noopener" className={classes.links}>
                        <Button>
                        {link.icon !== undefined 
                        ? 
                          <Icon className={link.icon} fontSize="large" 
                          style={link.style !== undefined ? link.style : {color:"#9bb2cf"/*"#647993"*/}}></Icon>
                          
                        : 
                          <Typography variant="subtitle1" color={link.color !== undefined ? link.color : "#9bb2cf"/*"#647993"*/}>{link.name}</Typography>
                        }
                        </Button>
                    </Link>
                  ))}
                  </Grid>
                </React.Fragment>

              }       
          </Grid>
        </Grid>
      </div>)
    );
}